import { useTranslation } from "react-i18next";
import {
  Group,
  Image,
  Title,
  Text,
  Stack,
  Container,
  ActionIcon,
  Flex,
} from "@mantine/core";
import { useState } from "react";
import { IconPlayerPlay } from "@tabler/icons-react";
import IconNiceDifference from "../../assets/images/ND Care+ Legacy.svg";
import { useMediaQuery } from "@mantine/hooks";
import Vimeo from "@u-wave/react-vimeo";
import { VideoURLs } from "../../models/constants/videoURLs";
import { InitialQuoteForm } from "../InitialQuoteForm/InitialQuoteForm";

export const HeroHeader = (props) => {
  const { t } = useTranslation();

  const isMobile = useMediaQuery("(max-width: 1024px)", true, {
    getInitialValueInEffect: false,
  });

  const [isPlaying, setIsPlaying] = useState(false);

  const handleVideoLoadAnalytics = () => {
    window.dataLayer.push({ event: "video_loaded" });
  };

  const marginTop = isMobile 
  ? (props.showNotificationBanner ? '180px' : '84px') 
  : (props.showNotificationBanner ? '150px' : '84px')

  const handleClick = () => {
    setIsPlaying(true);
  };

  const displayVideo = () => {
    return isPlaying ? (
      <Container className="player-wrapper" p={0}>
        <Container>
          <Vimeo
            video={VideoURLs.homepageVideo}
            className="react-player"
            controls={true}
            showTitle={false}
            responsive={true}
            autoplay={true}
            loop={false}
            onPlaying={() => {
              handleVideoLoadAnalytics();
            }}
          />
        </Container>
      </Container>
    ) : (
      <Container className="player-wrapper" onClick={() => handleClick()} p={0}>
        <Vimeo
          video={VideoURLs.homepageVideo}
          className="react-player"
          controls={false}
          showTitle={false}
          responsive={true}
          autoplay={false}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            cursor: "pointer",
          }}
        >
          <Group justify="center">
            <ActionIcon
              onClick={() => {
                handleClick();
              }}
              variant="default"
              size="xl"
              aria-label="Toggle color scheme"
            >
              <IconPlayerPlay stroke={1.5} />
            </ActionIcon>
          </Group>
        </div>
      </Container>
    );
  };

  return (
    <>
      <div
        style={{
          backgroundSize: "cover",
          marginTop: marginTop,
        }}
      >
        <Container size="xs">
          <Image src={IconNiceDifference} fit></Image>
        </Container>
        <Container size={"responsive"} px={0} bg={"#FFF"}>
          <Flex
            direction={isMobile ? "column" : "row"}
            p={isMobile ? "" : "0% 4% 0% 4%"}
            wrap="nowrap"
            grow
          >
            <Stack
              gap={8}
              p={isMobile ? "32px 6%" : "40px 40px 0px 0px"}
              w={"auto"}
              h={"100%"}
            >
              <Title
                ff={"Crimson Text"}
                fz={isMobile ? 40 : 56}
                fw={600}
                lh={"120%"}
                c={"#006b5b"}
              >
                {t("hero-header-title")}
              </Title>
              <Text
                ff={"Montserrat"}
                fz={isMobile ? 18 : 20}
                fw={"bold"}
                lh={"160%"}
                c={"#000000"}
              >
                {t("hero-header-text")}
              </Text>
              <Text
                ff={"Montserrat"}
                fz={isMobile ? 16 : 20}
                fw={400}
                lh={"155%"}
                c={"#000000"}
              >
                {t("hero-header-text-2")}
              </Text>
              {displayVideo()}
            </Stack>
            <InitialQuoteForm year={props.year} make={props.make} model={props.model} mileage={props.mileage} vin={props.vin} />
          </Flex>
        </Container>
      </div>
    </>
  );
};
